import { z } from 'my-zod'

export const PricingTierEnum = z.enum(['Core', 'Premium', 'ExceptionOnly'])
export type PricingTierEnum = z.infer<typeof PricingTierEnum>
